module.exports = __webpack_public_path__ + "b92677c7460e0447728d5b86c6702b01.pdf";